import { useTranslation } from "react-i18next";
import Input from "../components/common/Input";
import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { fetchForgotPassword } from "./FetchAuth";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("normal");
  const [errorsEmail, setErrorsEmail] = useState("");
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrorsEmail("");
  };
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchForgotPassword(email).then((data) => {
      if (data.success) {
        setState("success");
    } else {
        setState("error");
        setErrorsEmail("Email not found")
    }
  });
}

  if (state === "success") {
    return (
      <Navigate to="/forgot-send" email={email}/>
    );
  }


  return (
    <div className="forgot-password">
      <h1>{t("Forgot your password?")}</h1>
      <p className="paragraph">
        {t(
          "Please enter the email address associated with your account and we will email you a link to reset your password."
        )}
      </p>
      <form onSubmit={handleSubmit} className="forgot-password__form">
        <div className="form-default">
          <Input
            id="email"
            label={t("Email")}
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder={t("Enter email")}
            pattern=".*"
            state={state}
            alertState={errorsEmail}
          />
        </div>

        <button className="form-default__submit mt-20" type="submit">{t("Reset Password")}</button>
        <Link className="back-to-sign-in" to="/sign-in">{t("Back to Log in")}</Link>
      </form>
    </div>
  );
};

export default ForgotPassword;
